import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Table, ModalContext, AlloyButton } from 'cat-ecommerce-alloy';
import { getItemsReplacedCustomRenders } from '../utils';
import { TABLE_ITEM_PADDING, TABLE_ITEM_WIDTH } from '../constants';
import styles from '../styles.module.scss';

const CartImportSummaryItemsReplaced = ({ replacedPartList }) => {
  const { t } = useTranslation();
  const modalCtx = useContext(ModalContext);
  const replacedPartListKeys = replacedPartList?.map((item, index) => ({
    ...item,
    reactKey: index
  }));
  const schema = [
    {
      id: 'partQuantity',
      label: t('QUANTITY1'),
      width: TABLE_ITEM_WIDTH,
      padding: TABLE_ITEM_PADDING,
      hideOnMobile: true
    },
    {
      id: 'partNumber',
      label: t('NUMBER'),
      width: TABLE_ITEM_WIDTH,
      padding: TABLE_ITEM_PADDING,
      hideOnMobile: true
    },
    {
      id: 'partName',
      label: t('PART_NAME'),
      width: TABLE_ITEM_WIDTH,
      padding: TABLE_ITEM_PADDING,
      hideOnMobile: true
    },
    {
      id: 'itemsReplacedMobileCell',
      width: '90%',
      partQuantityLabel: t('QUANTITY1'),
      partNumberLabel: t('NUMBER'),
      partNameLabel: t('PART_NAME'),
      hideOnDesktop: true
    }
  ];

  const replaceShoppingCartLink = msg => {
    const msgSplit = msg.split('{0}');
    return (
      <span className={`${styles['cart-import-summary__text']}`}>
        {msgSplit[0]}
        <AlloyButton
          buttonType="link"
          size="large"
          className="p-0 pe-1 text-lowercase"
          data-testid="shoppingCartLink"
          onClick={modalCtx.removeCurrentModal}
        >
          {t('SHOPPINGCART_TITLE')}
        </AlloyButton>
      </span>
    );
  };

  return (
    <div className="mb-4">
      <h3 className="text-uppercase ps-1">{t('ITEMS_REPLACED')}</h3>
      <p className={`${styles['cart-import-summary__text']} mb-3 mt-3`}>
        {t('ITEMS_REPLACED_MSG3')}
      </p>
      <Table
        schema={schema}
        data={replacedPartListKeys}
        customRenderers={getItemsReplacedCustomRenders()}
      />
      <p className={`${styles['cart-import-summary__text']} mb-3 mt-3`}>
        {replaceShoppingCartLink(t('ITEMS_REPLACED_MSG2'))}
      </p>
    </div>
  );
};

export default CartImportSummaryItemsReplaced;

CartImportSummaryItemsReplaced.propTypes = {
  replacedPartList: PropTypes.arrayOf(
    PropTypes.shape({
      partQuantity: PropTypes.number,
      partName: PropTypes.string,
      partNumber: PropTypes.string
    })
  )
};
